import {Webhook} from "../../models/Webhook";
import {WrapperFactory} from "../WrapperFactory";

let baseUrl = '/api/company-webhooks';

let webhooksApi = {
    async get(page, token, companyId){
        let response = await window.axios.get(baseUrl, {
            params:{
                api_token:token,
                company_logged:companyId,
                page:page
            }
        });

        let wrapper = WrapperFactory.fromResponse(response.data)
        wrapper.transform(e=>new Webhook(e));
        return wrapper;
    },
    async create(webhook, token, companyId){
        let response = await window.axios.post(baseUrl, webhook, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new Webhook(response.data);
    },
    async edit(note, token, companyId){
        let response = await window.axios.put(baseUrl+'/'+note.id, note, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new Webhook(response.data);
    },
    async delete(note, token, companyId){
        let response = await window.axios.delete(baseUrl+'/'+note.id, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return !!response.data.success;
    },
}

export default webhooksApi